<template>
  <div class="center-box">
    <!-- <div class="login-tit">大兴生物医药产业基地智慧化危险废物管理平台</div> -->
    <div class="login-client">{{ clientText }}</div>
    <div class="login-toggle-client">
      <el-button
        type="text"
        icon="el-icon-refresh-right"
        @click="
          () => {
            isAdmin = !isAdmin;
          }
        "
        >{{ toogleText }}</el-button
      >
    </div>
    <div class="login-tit">
      <span>欢迎登录</span>
    </div>
    <el-form
      v-if="!isAdmin"
      :model="loginForm"
      :rules="rules"
      ref="loginForm"
      class="loginForm"
    >
      <el-form-item prop="name" class="login-item add-login-item">
        <el-input
          placeholder="请输入账号"
          prefix-icon="el-icon-user"
          v-model="loginForm.name"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password" class="login-item">
        <el-input
          placeholder="请输入密码"
          prefix-icon="el-icon-lock"
          v-model="loginForm.password"
          :show-password="true"
          maxlength="30"
        ></el-input>
      </el-form-item>
      <el-form-item prop="verifycode">
        <el-input
          placeholder="请输入验证码"
          prefix-icon="el-icon-key"
          v-model="loginForm.verifycode"
          maxlength="4"
        ></el-input>
        <img
          :src="verifycode"
          alt=""
          class="verify-code"
          @click="
            () => {
              version = new Date().valueOf();
            }
          "
        />
      </el-form-item>
      <!-- <div class="rememberPwd">
        <el-checkbox v-model="rememberPwd">记住密码</el-checkbox>
      </div> -->
      <el-form-item>
        <el-button
          style="
            width: 100%;
            margin-top: 20px;
            background-color: #3a61d7;
            letter-spacing: 12px;
            border-color: #3a61d7;
          "
          type="primary"
          class="btn-ok"
          @click="onSubmit()"
          >登录</el-button
        >
      </el-form-item>
    </el-form>

    <el-form
      v-else
      :model="adminLoginForm"
      :rules="rules"
      ref="adminLoginForm"
      class="loginForm"
    >
      <el-form-item prop="name" class="login-item add-login-item">
        <el-input
          placeholder="请输入账号"
          prefix-icon="el-icon-user"
          v-model="adminLoginForm.name"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password" class="login-item">
        <el-input
          placeholder="请输入密码"
          prefix-icon="el-icon-lock"
          v-model="adminLoginForm.password"
          :show-password="true"
          maxlength="30"
        ></el-input>
      </el-form-item>
      <el-form-item prop="verifycode">
        <el-input
          placeholder="请输入短信验证码"
          prefix-icon="el-icon-message"
          v-model="adminLoginForm.verifycode"
        >
          <el-button
            type="text"
            slot="suffix"
            :disabled="countdown"
            @click="getVerifyCode"
            >{{ buttonText }}</el-button
          >
        </el-input>
      </el-form-item>
      <!-- <div class="rememberPwd">
        <el-checkbox v-model="rememberPwd">记住密码</el-checkbox>
      </div> -->
      <el-form-item>
        <el-button
          style="
            width: 100%;
            margin-top: 20px;
            background-color: #3a61d7;
            letter-spacing: 12px;
            border-color: #3a61d7;
          "
          type="primary"
          class="btn-ok"
          @click="onAdminSubmit()"
          >登录</el-button
        >
      </el-form-item>
    </el-form>
    <!-- <div class="center-box-footer">
      <div>没有账号？去<span class="link" @click="linkTo('register')">注册</span></div>
      <div><span class="link" @click="linkTo('forgetPwd')">忘记密码</span>？</div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      countdown: false, // 表示按钮是否处于倒计时状态
      timeLeft: 60, // 表示剩余时间

      isAdmin: false,
      loginForm: {
        name: "",
        password: "",
        verifycode: "",
      },
      adminLoginForm: {
        name: "",
        password: "",
        verifycode: "",
      },

      version: new Date().valueOf(),
      // rememberPwd: false,
      rules: {
        name: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
        verifycode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    buttonText() {
      return this.countdown ? `${this.timeLeft}` : "获取验证码";
    },
    toogleText() {
      return this.isAdmin ? "切换企业端/处置端" : "切换政府端";
    },
    clientText() {
      return !this.isAdmin ? "企业端/处置端" : "政府端";
    },
    verifycode() {
      const server = "https://danger.envdata.top";
      // process.env.NODE_ENV === "development"
      //   ? "https://danger.envdata.top"
      //   : process.env.VUE_APP_BASE_API;
      return `${server}/api/v1/AppUsers/verifycode?v=${this.version}`;
    },
  },
  methods: {
    //获取验证码
    getVerifyCode() {
      if (!this.adminLoginForm.name) {
        this.$message.error("请输入用户名");
        return;
      }
      if (!this.adminLoginForm.password) {
        this.$message.error("请输入密码");
        return;
      }
      let url = this.$api.appUsers.loginSendSms;
      let params = {
        name: this.adminLoginForm.name,
        password: this.adminLoginForm.password,
      };
      this.$axios
        .post(url, this.$qs.stringify(params), false)
        .then((res) => {
          if (res.data.code === 0) {
            this.countdown = true;
            let timeInterval = setInterval(() => {
              this.timeLeft--;
              if (this.timeLeft === 0) {
                clearInterval(timeInterval);
                this.countdown = false;
                this.timeLeft = 60;
              }
            }, 1000);
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        })
        .catch((err) => {
          console.log("失败");
        });
    },
    linkTo(page) {
      this.$emit("linkTo", page);
    },
    checkRoutePermission(to, permissionList) {
      let isValidate = false;
      if (to.meta.permissionPath) {
        isValidate = to.meta.permissionPath.some((item) =>
          permissionList.includes(item)
        );
      }
      return isValidate;
    },
    onSubmit() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          let url = this.$api.Login;
          this.$axios
            .post(url, this.$qs.stringify(this.loginForm), false)
            .then((res) => {
              if (res.data.code == 0) {
                //登录成功写入权限
                let routers = this["$router"].options.routes; // 获取路由对象routes
                let permission = [res.data.data.role]; //["a", "b"];
                let arrMenu = routers.filter((item) => {
                  if (item.meta && item.noDropdown) {
                    if (this.checkRoutePermission(item, permission)) {
                      return item;
                    }
                  }
                });
                // // 暂时自己写的假权限
                sessionStorage.setItem(
                  "permission",
                  JSON.stringify(permission)
                );
                sessionStorage.setItem("getMenuList", JSON.stringify(arrMenu));
                sessionStorage.setItem(
                  "tokenData",
                  JSON.stringify(res.data.data)
                );
                // this.getSearchList();
                // this.getSearchCityList();

                if (arrMenu[0].children && arrMenu[0].children.length > 0) {
                  this.$router.push(arrMenu[0].children[0]);
                } else {
                  this.$router.push(arrMenu[0]);
                }
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onAdminSubmit() {
      this.$refs.adminLoginForm.validate((valid) => {
        if (valid) {
          let url = this.$api.AdminLogin;
          this.$axios
            .post(url, this.$qs.stringify(this.adminLoginForm), false)
            .then((res) => {
              if (res.data.code == 0) {
                //登录成功写入权限
                let routers = this["$router"].options.routes; // 获取路由对象routes
                let permission = [res.data.data.role]; //["a", "b"];
                let arrMenu = routers.filter((item) => {
                  if (item.meta && item.noDropdown) {
                    if (this.checkRoutePermission(item, permission)) {
                      return item;
                    }
                  }
                });
                // // 暂时自己写的假权限
                sessionStorage.setItem(
                  "permission",
                  JSON.stringify(permission)
                );
                sessionStorage.setItem("getMenuList", JSON.stringify(arrMenu));
                sessionStorage.setItem(
                  "tokenData",
                  JSON.stringify(res.data.data)
                );
                // this.getSearchList();
                // this.getSearchCityList();

                if (arrMenu[0].children && arrMenu[0].children.length > 0) {
                  this.$router.push(arrMenu[0].children[0]);
                } else {
                  this.$router.push(arrMenu[0]);
                }
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-form-item__content {
  display: flex;
}
.login-client {
  position: absolute;
  top: 12px;
  left: 12px;
}
.login-toggle-client {
  position: absolute;
  top: 0px;
  right: 12px;
}
.verify-code {
  cursor: pointer;
  width: 140px;
  height: 40px;
  margin-left: 20px;
  border: 1px solid #ccc;
  border-radius: 3px;
}
</style>
